// MUI
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";

export const OverEntitlementDialog = ({
  open,
  setOpen,
  reason,
  setReason,
  saveOrder,
  saveData,
  setDataToSave,
  orderSummary,
}) => {
  const handleClose = () => {
    setOpen(false);
    setReason("");
  };

  const handleAddItem = () => {
    const updatedObj = {
      ...saveData,
      data: {
        ...saveData.data,
        lines: [
          {
            ...saveData.data.lines[0],
            overEntitlementReason: reason,
          },
        ],
      },
    };

    setDataToSave(updatedObj);

    saveOrder(updatedObj);
    setReason("");
    setOpen(false);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={open}
      onClose={handleClose}
      aria-labelledby="over-entitlement-dialog"
    >
      <DialogTitle id="over-entitlement-dialog-title">
        Item Over Entitlement
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          This item is over entitlement. Please enter a reason to continue.
        </DialogContentText>

        <TextField
          sx={{ mt: 1 }}
          id="reason-input"
          fullWidth
          label="Reason"
          value={reason}
          onChange={(event) => {
            setReason(event.target.value);
          }}
          slotProps={{
            htmlInput: { maxLength: 99 },
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleAddItem}
          disabled={reason === ""}
        >
          {orderSummary ? "Update" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
